import { useState } from "react";
import { useNavigate } from "react-router";
import ReductionsTable from "../../../components/ReductionsTable";
import RoundedCard from "../../../components/RoundedCard";
import { useReductions } from "@/hooks/useReductions";
import ReductionUploadDialog from "./ReductionUploadDialog";

type ReductionsDocumentTabProps = {
  detailPathPrefix?: string;
  description: string | null;
  reported?: boolean | null;
  showStatusColumn?: boolean;
  title: string;
};

const REDUCTIONS_PAGE_SIZE = 10;

const ReductionsDocumentTab = ({
  detailPathPrefix = "",
  description,
  reported,
  showStatusColumn = true,
  title,
}: ReductionsDocumentTabProps) => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const {
    data: response,
    isError,
    isFetching,
    isLoading,
  } = useReductions({
    page,
    page_size: REDUCTIONS_PAGE_SIZE,
    reported,
  });

  const handleReductionClick = (documentId: string) => {
    void navigate(`${detailPathPrefix}reduktion/${documentId}`);
  };

  return (
    <RoundedCard
      bodyClassName="p-0 mt-3"
      header={title}
      description={description}
      action={<ReductionUploadDialog />}
    >
      <ReductionsTable
        isError={isError}
        isLoading={isLoading}
        onReductionClick={handleReductionClick}
        reductions={response?.items ?? []}
        showStatusColumn={showStatusColumn}
        pagination={
          response
            ? {
                isDisabled: isFetching,
                onPageChange: setPage,
                page: response.page,
                total: response.total,
                totalPages: response.totalPages,
              }
            : undefined
        }
      />
    </RoundedCard>
  );
};

export default ReductionsDocumentTab;
